import { Eye } from "@phosphor-icons/react";
import { cn } from "../lib/cn";

/* The reusable private-data indicator, introduced on the onboarding identity
 * screen. One copy string everywhere so the icon teaches its own meaning. */
export const PRIVACY_EYE_COPY =
  "Anytime you see this icon, it means your data is private. Your employer can never see it.";

export interface PrivacyEyeProps {
  className?: string;
  size?: number;
}

export function PrivacyEye({ className, size = 15 }: PrivacyEyeProps) {
  return (
    <span
      role="img"
      aria-label={PRIVACY_EYE_COPY}
      className={cn(
        "group relative inline-flex flex-none cursor-help items-center justify-center text-ink-brand",
        className,
      )}
    >
      <Eye size={size} weight="duotone" aria-hidden="true" />
      <span className="pointer-events-none absolute left-1/2 top-full z-30 mt-2 hidden w-max max-w-[250px] -translate-x-1/2 whitespace-normal rounded-lg border border-border-default bg-surface-elevated px-3 py-2 text-left font-sans text-sm font-medium normal-case leading-snug tracking-normal text-ink-secondary shadow-card group-hover:block">
        {PRIVACY_EYE_COPY}
      </span>
    </span>
  );
}
